// All mock/static content for the BEE Exsellance site.
// Later, dynamic bits (contact + quote submission) will hit the backend.

export const company = {
  name: "BEE Exsellance",
  full: "BEE Exsellance (Pty) Ltd",
  tagline: "Your B-BBEE Advisor",
  phones: ["+27 10 502 2788", "+27 84 039 4579"],
  whatsapp: "27840394579", // digits only for wa.me link
  email: "tonde@exsebee.co.za",
  address: "533 Long Avenue, Ferndale, Randburg, 2194",
  yearsInBusiness: 11,
  hours: "Mon – Fri: 08:00 – 17:00",
  freeConsult: "First consultation free of charge",
};

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Sectors", to: "/sectors" },
  { label: "Resources", to: "/resources" },
  { label: "Request a Quote", to: "/pricing-calculator" },
  { label: "Contact", to: "/contact" },
];

export const heroSlides = [
  {
    eyebrow: "We Are Ready To Assist",
    title: "Get an Obligation-Free B-BBEE Quote Today",
    text: "Partner with a firm that is efficient, focused and available to power your growth. Book a consultation with our B-BBEE experts.",
    cta: { label: "Get Instant Quote", to: "/pricing-calculator" },
    cta2: { label: "Book Consultation", to: "/contact" },
    image:
      "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGNvbnN1bHRpbmclMjBtZWV0aW5nfGVufDB8fHx8MTc4NjAwNjkyOXww&ixlib=rb-4.1.0&q=85",
  },
  {
    eyebrow: "We Are BEE Exsellance",
    title: "Tailored Solutions Aligned To Your Requirements",
    text: "Our objective is to fulfil the needs and desires of our clients by delivering tailored solutions that align precisely with their requirements.",
    cta: { label: "Explore More", to: "/about" },
    cta2: { label: "Our Services", to: "/services" },
    image:
      "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjB0ZWFtd29yayUyMG9mZmljZXxlbnwwfHx8fDE3ODYwMDY5Mjl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    eyebrow: "We Are At Your Service",
    title: "Guiding You At Every Stage Of Your B-BBEE Journey",
    text: "With our diverse capabilities, we are dedicated to assisting you at every stage of your Broad-Based Black Economic Empowerment journey.",
    cta: { label: "Our Services", to: "/services" },
    cta2: { label: "Contact Us", to: "/contact" },
    image:
      "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGNvbnN1bHRpbmclMjBtZWV0aW5nfGVufDB8fHx8MTc4NjAwNjkyOXww&ixlib=rb-4.1.0&q=85",
  },
];

export const featureCards = [
  {
    icon: "Target",
    title: "Strategic Planning",
    text: "We help clients define and reach their long-term strategic objectives.",
  },
  {
    icon: "Rocket",
    title: "Strategy Execution",
    text: "We help make your company's strategic plan actually happen.",
  },
  {
    icon: "TrendingUp",
    title: "Revenue Growth",
    text: "We craft practical ways to increase your business' revenue.",
  },
  {
    icon: "LineChart",
    title: "Business Growth",
    text: "We help make your business bigger, stronger and more successful.",
  },
];

export const aboutIntro = {
  eyebrow: "About Our Company",
  title: "We Assist the Corporate Sector With All Aspects of B-BBEE Legislation",
  body: "BEE Exsellance (Pty) Ltd is a Broad-Based Black Economic Empowerment (B-BBEE) consulting and advisory firm that assists the corporate sector with all aspects of B-BBEE legislation, and supports the implementation of strategic plans that are efficient and cost-effective.",
  points: [
    "Sensitivity to client needs",
    "Commitment to client success",
    "Dedication to delivering value",
    "Strict adherence to standards",
  ],
  image:
    "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjB0ZWFtd29yayUyMG9mZmljZXxlbnwwfHx8fDE3ODYwMDY5Mjl8MA&ixlib=rb-4.1.0&q=85",
};

export const stats = [
  { value: 11, suffix: "+", label: "Years in Business" },
  { value: 120, suffix: "+", label: "Clients Assisted" },
  { value: 100, suffix: "%", label: "Compliance Focus" },
  { value: 6, suffix: "", label: "Core Service Lines" },
];

export const services = [
  {
    slug: "training",
    icon: "GraduationCap",
    title: "B-BBEE Training",
    short: "One-on-one or group sessions with our specialist B-BBEE training team.",
    long: "One-on-one or group sessions with our specialist B-BBEE training team on the B-BBEE Codes and all aligned sectors, giving your people the knowledge to drive compliance from within.",
    image:
      "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGNvbnN1bHRpbmclMjBtZWV0aW5nfGVufDB8fHx8MTc4NjAwNjkyOXww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "consulting",
    icon: "ClipboardList",
    title: "B-BBEE Consulting",
    short: "We review and advise on your company's B-BBEE policies and strategies.",
    long: "We review and advise on the company's B-BBEE policies and strategies before implementation. This includes a complete gap analysis, corrective actions and a practical guide to implementation.",
    image:
      "https://images.unsplash.com/photo-1551836022-d5d88e9218df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMGNvbnN1bHRpbmclMjBtZWV0aW5nfGVufDB8fHx8MTc4NjAwNjkyOXww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "verification",
    icon: "ShieldCheck",
    title: "B-BBEE Verification Prep",
    short: "We assist your company in collating the correct information required.",
    long: "A dedicated team assists your company in collating the correct information required for the rating process and compiling a rating to be presented to the verification team — removing surprises on the day.",
    image:
      "https://images.unsplash.com/photo-1568992687947-868a62a9f521?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjB0ZWFtd29yayUyMG9mZmljZXxlbnwwfHx8fDE3ODYwMDY5Mjl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "employment-equity",
    icon: "Users",
    title: "Employment Equity Consulting",
    short: "EE Plans, committee setup, meetings and EEA2 submissions.",
    long: "Our range includes an Employment Equity Plan, establishment of your EE committee and relevant structures, assistance with EE committee meetings, and adherence to general procedures flowing into your annual EEA2 submission.",
    image:
      "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxjb3Jwb3JhdGUlMjB0ZWFtd29yayUyMG9mZmljZXxlbnwwfHx8fDE3ODYwMDY5Mjl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "gap-analysis",
    icon: "Search",
    title: "Gap Analysis",
    short: "Similar to the rating process, plus an analysis of your processes.",
    long: "Similar to the rating process, but over and above collecting and verifying information, we analyse your current processes and systems to identify exactly where the gaps and opportunities lie.",
    image:
      "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGNvbnN1bHRpbmclMjBtZWV0aW5nfGVufDB8fHx8MTc4NjAwNjkyOXww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "transaction-management",
    icon: "Handshake",
    title: "Transaction Management",
    short: "Clearly defined scope, responsibilities and deliverables.",
    long: "BEE transactions may seem simple, but they are not. Transactions should clearly define scope, responsibilities and deliverables. Let's get the basics right to avoid disappointments in future.",
    image:
      "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjB0ZWFtd29yayUyMG9mZmljZXxlbnwwfHx8fDE3ODYwMDY5Mjl8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const whyChoose = {
  eyebrow: "Why Choose BEE Exsellance",
  title: "A Trusted Business Advisor to Help You Grow",
  body: "We strive to increase your B-BBEE score while driving real transformation. Through our work we develop integrated, inclusive strategies that help your business grow — while helping your customers, employees and community prosper right along with you.",
  points: [
    "We apply extensive industry knowledge and experience",
    "A proven track record of success with our clients",
    "We tailor plans specifically for your business",
    "We help grow your profits and business value",
    "Our services and methods deliver tangible ROI",
  ],
};

export const founder = {
  name: "Tonderai",
  title: "Founder & Lead B-BBEE Advisor",
  photo: "/founder.jpg",
  intro: "Over a decade of turning B-BBEE compliance into real growth.",
  bio: [
    "BEE Exsellance was founded on more than 10 years of experience spanning external auditing, credit analysis and Broad-Based Black Economic Empowerment — with a clear purpose: to help South African businesses turn B-BBEE from a box-ticking exercise into a genuine growth advantage.",
    "That auditing and finance heritage brings a rare rigour to every engagement, combining sharp analytical insight with a practical, results-driven approach to transformation. The team works closely with each client to build scorecards and strategies that are accurate, defensible and aligned to their commercial goals.",
    "This expertise is anchored by an MBA from the Johannesburg Business School, a B-BBEE Management Development Programme from Wits Business School, and a BSc (Hons) in Banking & Finance — a foundation that lets the firm view your business through both a compliance and a commercial lens.",
  ],
  expertise: [
    "10+ Years B-BBEE Experience",
    "External Auditing",
    "Credit Analysis",
    "B-BBEE Strategy & Implementation",
  ],
};


export const missionVision = {
  vision:
    "To take the lead, motivate, and empower aspiring entrepreneurs in the ongoing battle against poverty, aligned with the government's \"Growth Path\" initiative.",
  mission:
    "To fulfil the needs and desires of our clients by providing tailored solutions that align with their requirements, recognising the significant impact of entrepreneurship on economic growth.",
  values: ["Quality", "Impact", "Innovation"],
};

export const referencesNote =
  "We respect our clients' confidentiality. Verifiable references and case studies are gladly provided on request during your consultation.";

// Industries / sectors we provide B-BBEE consulting to
export const sectors = [
  { icon: "Factory", title: "Manufacturing & Industrial", text: "Scorecard strategy and evidence management for factories, plants and industrial suppliers." },
  { icon: "Pickaxe", title: "Mining & Resources", text: "Alignment with the Mining Charter and Generic Codes for exploration, extraction and processing." },
  { icon: "Landmark", title: "Financial Services", text: "Guidance under the Financial Sector Code (FSC) for banks, insurers and asset managers." },
  { icon: "Cpu", title: "ICT & Technology", text: "ICT Sector Code support for software, telecoms, hardware and digital-services businesses." },
  { icon: "HardHat", title: "Construction & Engineering", text: "Construction Sector Code strategy for contractors, developers and built-environment firms." },
  { icon: "ShoppingCart", title: "Retail, Wholesale & FMCG", text: "Practical transformation plans for retailers, distributors and fast-moving consumer goods." },
  { icon: "HeartPulse", title: "Healthcare & Pharmaceuticals", text: "Compliance for hospitals, clinics, pharma manufacturers and medical distributors." },
  { icon: "Sprout", title: "Agriculture & Agri-processing", text: "AgriBEE Sector Code support across primary production and agri-processing value chains." },
  { icon: "Truck", title: "Transport & Logistics", text: "Transport Sector Code alignment for freight, fleet, courier and supply-chain operators." },
  { icon: "Plane", title: "Tourism & Hospitality", text: "Tourism Sector Code guidance for hotels, lodges, travel and hospitality groups." },
  { icon: "Building2", title: "Property & Real Estate", text: "Property Sector Code strategy for developers, landlords and estate managers." },
  { icon: "Zap", title: "Energy & Utilities", text: "Transformation support for renewables, power, water and utility service providers." },
  { icon: "Briefcase", title: "Professional Services", text: "Scorecard optimisation for legal, accounting, engineering and advisory practices." },
  { icon: "GraduationCap", title: "Education & Training", text: "Compliance and skills-development strategy for training providers and institutions." },
  { icon: "Megaphone", title: "Media, Advertising & Communication", text: "MAC Sector Code support for agencies, publishers and communication businesses." },
  { icon: "Building", title: "Public Sector & SOEs", text: "Advisory for government entities, municipalities and state-owned enterprises." },
];

export const sectorCodes = [
  "Generic Codes of Good Practice",
  "Financial Sector Code (FSC)",
  "ICT Sector Code",
  "Construction Sector Code",
  "Tourism Sector Code",
  "Transport Sector Code",
  "AgriBEE Sector Code",
  "Property Sector Code",
  "MAC (Marketing, Advertising & Communication) Code",
  "Chartered Accountancy (CA) Charter",
  "Forestry Sector Code",
  "Defence Sector Code",
];

export const faqs = [
  {
    q: "Who qualifies as a black person for purposes of B-BBEE?",
    a: "B-BBEE seeks to advance access of black people in the South African economy. \"Black people\" is a generic term meaning Africans, Coloureds and Indians who are citizens of the Republic of South Africa by birth or descent; or who became citizens by naturalisation before 27 April 1994, or on/after that date where they would have been entitled to acquire citizenship by naturalisation prior to that date.",
  },
  {
    q: "How is B-BBEE classification determined?",
    a: "Entities are classified by annual turnover: Start-up Enterprise (in operation under one year); Exempted Micro-Enterprises / EMEs (turnover of R0 to under R10 million); Qualifying Small Enterprises / QSEs (above R10 million to under R50 million); and Large Enterprises (turnover above R50 million).",
  },
  {
    q: "Is it an offence to split or divide an entity?",
    a: "In terms of Para 2.5 Codes Series 000, if an entity splits itself to ensure eligibility as an EME or QSE, such conduct constitutes an offence and will be dealt with in terms of the Act.",
  },
  {
    q: "How can an EME enhance its B-BBEE status?",
    a: "An EME that intends to enhance its B-BBEE status must be verified against the QSE scorecard.",
  },
  {
    q: "Who must register the major B-BBEE transaction?",
    a: "A party that enters into a transaction with a value of R25 million or more, where such transaction results in ownership recognition.",
  },
];

export const serviceOptions = [
  "Quote Request",
  "Service Enquiry",
  "B-BBEE Training",
  "B-BBEE Consulting",
  "Verification Preparation",
  "Employment Equity",
  "Gap Analysis",
  "Other",
];

// Quote form dropdowns (labels only — pricing weights live on the backend)
export const ownershipChoices = [
  { value: "simple", label: "Simple local ownership" },
  { value: "multiple", label: "Multiple shareholders" },
  { value: "trust", label: "Trust / broad-based structure" },
  { value: "group", label: "Group / multinational structure" },
];

export const serviceIntensityChoices = [
  { value: "quarterly", label: "Quarterly advisory" },
  { value: "standard", label: "Standard monthly consulting" },
  { value: "full", label: "Full monthly implementation" },
  { value: "outsourced", label: "Outsourced B-BBEE function" },
];

// Downloadable, branded B-BBEE affidavit templates (generated by the backend)
export const affidavitTemplates = [
  { kind: "generic-eme", title: "Generic EME Affidavit", tag: "EME", desc: "Standard Exempted Micro Enterprise sworn affidavit under the Generic Codes — for entities with annual turnover under R10 million." },
  { kind: "generic-qse", title: "Generic QSE Affidavit", tag: "QSE", desc: "Standard Qualifying Small Enterprise sworn affidavit under the Generic Codes — for turnover between R10m and R50m." },
  { kind: "specialised-eme", title: "Specialised Entity EME Affidavit", tag: "Specialised", desc: "For Specialised Enterprises (organs of state, public entities, NPOs, institutions) measured as an EME — revenue under R10 million." },
  { kind: "specialised-qse", title: "Specialised Entity QSE Affidavit", tag: "Specialised", desc: "For Specialised Enterprises measured as a QSE on the specialised scorecard — revenue between R10m and R50m." },
];
